if (!customElements.get("build-your-pc")) {
  class BuildYourPC extends HTMLElement {
    constructor() {
      super();
      this.currentStepIndex = 0;
      this.steps = [];
      this.popup = null;
      this.notificationTimeout = null;
      this.stepsDetailsList = [];
      this.popupType = null;
      this.isSubmitting = false;
      this.baseUrl = "https://quadrastores.com/collections/build-your-pc?sort_by=title-ascending&filter.v.availability=1&filter.v.price.gte=&filter.v.price.lte=&page=";
      this.collectionProducts = [];
      this.enableDiscount = JSON.parse(this.dataset.enableDiscount);
      this.bundleDiscount = parseInt(this.dataset.bundleDiscount);
    }

    connectedCallback() {
      this.init();
    }

    async init() {
      this.steps = Array.from(this.querySelectorAll(".pc-build-step"));
      this.stepDetailContainer = this.querySelector(".pc-build-step-detail");
      this.totalPriceEl = this.querySelector(".total-price");
      this.finalPriceEl = this.querySelector(".final-price");
      this.addToCartBtn = this.querySelector(".pc-build-step-detail__atc");
      this.buyNowBtn = this.querySelector(".pc-build-step-detail__buy-now");
      this.nextStepBtn = this.querySelectorAll(".pc-build-step-detail__next-btn");
      this.prevStepBtn = this.querySelectorAll(".pc-build-step-detail__prev-btn");
      this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      this.carousel = this.querySelector("build-your-pc-carousel");
      this.addProductBtn = this.querySelector(".pc-build-step-details__add-btn");
      this.wrapper = this.querySelector(".pc-build-steps-wrapper");
      this.toggleBtn = this.querySelector(".pc-toggle-steps-btn");
      this.allSteps = this.querySelectorAll(".pc-step-item");

      await this.fetchCollectionProducts();

      if (!this.steps.length) {
        console.error("No steps found for PC Builder!");
        return;
      }

      this.steps.forEach((step, index) => {
        step.addEventListener("click", () => {
          let isAllReqStepProductsSelected = true;

          for (let eachIndex = 0; eachIndex < this.steps.length; eachIndex++) {
            const eachStep = this.steps[eachIndex];
            const eachStepData = eachStep.dataset.meta ? JSON.parse(eachStep.dataset.meta) : null;

            if (eachIndex < index && eachStepData?.required_step) {
              const stepProducts = this.stepsDetailsList[eachIndex].stepProducts;

              if (stepProducts.length === 0) {
                isAllReqStepProductsSelected = false;
                break;
              }
            }
          }

          if (!isAllReqStepProductsSelected) {
            this.showErrorNotification("Please select a product before moving to the next step.");
            return;
          }

          this.showStepDetail(index);
        });

        const stepData = step.dataset.meta ? JSON.parse(step.dataset.meta) : null;
        this.stepsDetailsList.push({
          stepName: stepData !== null ? stepData.title : null,
          stepType: stepData !== null ? stepData.type : null,
          stepIndex: index,
          isRequiredStep: stepData !== null ? stepData.required_step : false,
          isMultiSelectionStep: stepData !== null ? stepData.multiple_selection : false,
          isCompatibilityRequiredStep: stepData !== null ? stepData.check_compatibility : false,
          stepProducts: []
        })
      });


      this.nextStepBtn?.forEach(btn => {
        btn.addEventListener("click", () => this.nextStep());
      });
      this.prevStepBtn?.forEach(btn => {
        btn.addEventListener("click", () => this.prevStep());
      });
      this.addToCartBtn?.addEventListener("click", () => this.addToCart());
      this.buyNowBtn?.addEventListener("click", () => this.buyNow());
      this.addProductBtn?.addEventListener("click", () => this.renderSelectBtns('newSelectBtn'));

      this.showStepDetail(this.currentStepIndex);

      if (!this.wrapper || !this.toggleBtn) return;
      this.totalSteps = this.allSteps.length;
      this.toggleShowMoreSteps();
    }

    async fetchCollectionProducts(){
      const productGrid = document.getElementById("product-grid");
      if (!productGrid) return;

      const shimmerEl = this.querySelector('.build-your-pc__shimmer');
      const mainContentEl = this.querySelector('.pc-build-steps');

      if (shimmerEl) shimmerEl.classList.remove('hidden');
      if (mainContentEl) mainContentEl.classList.add('hidden');

      const totalProductsCount = parseInt(productGrid.dataset.productsCount);
      const perPageProductsCount = parseInt(productGrid.dataset.perpageCount);
      const totalPages = Math.ceil(totalProductsCount / perPageProductsCount);
      const urls = Array.from({ length: totalPages }, (_, i) => `${this.baseUrl}${i + 1}`);

      try {
        const responses = await Promise.all(urls.map(url => fetch(url)));
        const texts = await Promise.all(responses.map(res => res.text()));

        texts.forEach(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const pageNodes = doc.querySelectorAll("#product-grid .grid__item");
          const pageProducts = [...pageNodes]
          .filter((eachProduct) => eachProduct.dataset.productAvailable === "true")
          .map(eachProduct => ({
            id: eachProduct.dataset.productId,
            product_handle: eachProduct.dataset.productHandle,
            variant_id: eachProduct.dataset.variantId,
            title: eachProduct.dataset.productTitle,
            price: eachProduct.dataset.variantPrice,
            url: eachProduct.dataset.productUrl,
            image: eachProduct.dataset.productImage,
            step_type: eachProduct.dataset.stepType,
            brand: eachProduct.dataset.brand,
            compatibleProcessor: eachProduct.dataset.compatibleProcessor.split(","),
            compatibleMotherBoard: eachProduct.dataset.compatibleMotherBoard.split(","),
            compatibleVga: eachProduct.dataset.compatibleVga.split(","),
            compatibleRam: eachProduct.dataset.compatibleRam.split(","),
            compatibleStorageDevice: eachProduct.dataset.compatibleStorageDevice.split(","),
            compatiblePowerSupply: eachProduct.dataset.compatiblePowerSupply.split(","),
            compatibleCooler: eachProduct.dataset.compatibleCooler.split(","),
            compatibleCase: eachProduct.dataset.compatibleCase.split(",")
          }));

          this.collectionProducts.push(...pageProducts);
        });

        console.log("All products with metafields loaded:", this.collectionProducts);

      } catch (error) {
        console.error("Failed to fetch products:", error);
      }

      if (shimmerEl) shimmerEl.classList.add('hidden');
      if (mainContentEl) mainContentEl.classList.remove('hidden');
    }

    async fetchRemainingProductsIfNeeded() {
      const totalCount = parseInt(this.collectionDataScript.dataset.totalCount || "0");
      const handle = this.collectionDataScript.dataset.handle;
      const pageSize = 100;

      const totalPages = Math.ceil(totalCount / pageSize);

      const shimmerEl = this.querySelector('.build-your-pc__shimmer');
      const mainContentEl = this.querySelector('.pc-build-steps');

      if (shimmerEl) shimmerEl.classList.remove('hidden');
      if (mainContentEl) mainContentEl.classList.add('hidden');

      if (totalPages <= 1) {
        console.log("All products loaded in initial page.");

        if (shimmerEl) shimmerEl.classList.add('hidden');
        if (mainContentEl) mainContentEl.classList.remove('hidden');

        return;
      }

      for (let currentPage = 2; currentPage <= totalPages; currentPage++) {
        const url = `/collections/${handle}?page=${currentPage}`;
        try {
          const res = await fetch(url);
          const html = await res.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const nextScript = doc.querySelector("#collection-data");

          if (!nextScript) {
            console.warn(`No product data found on page ${currentPage}`);
            break;
          }

          const parsed = JSON.parse(nextScript.textContent);
          const moreProducts = parsed.products || [];

          if (moreProducts.length === 0) {
            console.warn(`Page ${currentPage} returned no products. Stopping.`);
            break;
          }

          console.log(`Loaded page ${currentPage}: ${moreProducts.length} products`);
          this.collectionProducts.push(...moreProducts);
        } catch (error) {
          console.error(`Failed to fetch page ${currentPage}:`, error);
          break;
        }
      }

      console.log("All products with metafields loaded:", this.collectionProducts);

      if (shimmerEl) shimmerEl.classList.add('hidden');
      if (mainContentEl) mainContentEl.classList.remove('hidden');
    }

    showErrorNotification(message) {
      const notification = document.querySelector('.build-your-pc__notification');
      const messageText = notification?.querySelector('.notification-text');

      if (notification && messageText) {
        messageText.textContent = message;
        notification.classList.remove("hidden");
        notification.classList.add("show");

        if (this.notificationTimeout) {
          clearTimeout(this.notificationTimeout);
        }

        this.notificationTimeout = setTimeout(() => {
          notification.classList.remove("show");
          setTimeout(() => {
            notification.classList.add("hidden");
          }, 300);
          this.notificationTimeout = null;
        }, 3000);
      }
    }

    showStepDetail(index) {
      if (index < 0 || index >= this.steps.length) return;


      this.steps.forEach((s) => s.classList.remove("active-step"));
      this.steps[index].classList.add("active-step");
      this.currentStepIndex = index;
      const step = this.steps[index];
      const stepData = step.dataset.meta ? JSON.parse(step.dataset.meta) : null;
      
      if (!stepData) {
        console.error("Missing meta data for step", step);
        return;
      }

      
      if (this.carousel?.goToStep) {
        this.carousel.goToStep(index);
      }
      
      const isMultiSelectionStep = stepData.multiple_selection;
      const titleEl = this.stepDetailContainer.querySelector(".pc-build-detail-title");
      const stepTypeText = this.stepDetailContainer.querySelector(".pc-build-step-type");
      const popupBtnWrapper = this.stepDetailContainer.querySelector(".pc-build-step-detail__open-popup-wrapper");
      const popupBtnList = this.stepDetailContainer.querySelector(".pc-build-step-detail__open-popup-list");
      const popupBtns = this.stepDetailContainer.querySelectorAll(".pc-build-step-detail__open-popup");
      const checkboxContainer = this.stepDetailContainer.querySelector(".pc-build-step-detail__checkbox-container");
      const productSelectedText = this.stepDetailContainer.querySelector(".product-selected-text");
      popupBtnList.innerHTML = "";
      const requiredStepText = stepData.required_step ? "Required" : "Optional";

      if (titleEl) titleEl.textContent = `Choose ${stepData.title}` ;
      if (stepTypeText) stepTypeText.textContent = `(${requiredStepText})`;

      if (!popupBtns) return;

      switch (stepData.type) {
        case "popup":
          popupBtnWrapper.style.display = "block";
          if (isMultiSelectionStep) {
            this.addProductBtn.classList.remove('hidden');
          }else {
            this.addProductBtn.classList.add('hidden');
          }
          this.popupType = stepData.type;
          this.renderSelectBtns();
          if (checkboxContainer) checkboxContainer.innerHTML = "";
          break;

        case "popup filters":
          popupBtnWrapper.style.display = "block";
          if (isMultiSelectionStep) {
            this.addProductBtn.classList.remove('hidden');
          }else {
            this.addProductBtn.classList.add('hidden');
          }
          this.popupType = stepData.type;
          this.renderSelectBtns();
          if (checkboxContainer) checkboxContainer.innerHTML = "";
          break;

        case "checkbox":
          popupBtnWrapper.style.display = "block";
          this.addProductBtn.classList.add('hidden');
          this.popupType = null;
          if (checkboxContainer) {
            this.renderCheckboxSelector(stepData, checkboxContainer);
          }
          break;

        default:
          popupBtnWrapper.style.display = "none";
          this.popupType = null;
          if (checkboxContainer) checkboxContainer.innerHTML = "";
          break;
      }

      this.updatePrevNextButtons();
    }

    addSelectBtn(stepProduct = null){
      const productTitle = stepProduct !== null ? stepProduct.title : 'Select';
      const productPrice = stepProduct !== null ? stepProduct.price : '00'
      const productId = stepProduct !== null ? stepProduct.id : "";
      const hiddenClass = stepProduct !== null ? '' : 'hidden'
      return `
        <li class="pc-build-step-detail__open-item tw-w-full">
          <div class="pc-build-step-detail__open-popup products-popup tw-uppercase tw-mb-[0.8rem]" data-open-popup data-title="${productTitle}" data-product-id="${productId}">
            <div class="product-selected-text">
              <div class="step-selected-product">
                <h3 class="popup-product-title">${productTitle}</h3>
                <p class="popup-product-price ${hiddenClass}">KD ${productPrice}</p>
              </div>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M17.0306 12.5306L9.53055 20.0306C9.46087 20.1003 9.37815 20.1556 9.2871 20.1933C9.19606 20.231 9.09847 20.2504 8.99993 20.2504C8.90138 20.2504 8.8038 20.231 8.71276 20.1933C8.62171 20.1556 8.53899 20.1003 8.4693 20.0306C8.39962 19.9609 8.34435 19.8782 8.30663 19.7872C8.26892 19.6961 8.24951 19.5986 8.24951 19.5C8.24951 19.4015 8.26892 19.3039 8.30663 19.2128C8.34435 19.1218 8.39962 19.0391 8.4693 18.9694L15.4396 12L8.4693 5.03063C8.32857 4.8899 8.24951 4.69903 8.24951 4.50001C8.24951 4.30098 8.32857 4.11011 8.4693 3.96938C8.61003 3.82865 8.80091 3.74959 8.99993 3.74959C9.19895 3.74959 9.38982 3.82865 9.53055 3.96938L17.0306 11.4694C17.1003 11.539 17.1556 11.6218 17.1933 11.7128C17.2311 11.8038 17.2505 11.9014 17.2505 12C17.2505 12.0986 17.2311 12.1962 17.1933 12.2872C17.1556 12.3783 17.1003 12.461 17.0306 12.5306Z" fill="white"/>
              </svg>
          </div>
          <div class="tw-mb-[0.8rem] ${hiddenClass} popup-btn-qty-selector" data-product-id=${productId}>
            <div class="tw-inline-flex tw-items-center tw-justify-between bmd:tw-gap-[1.5rem] md:tw-gap-[3rem] tw-px-[1.1rem] tw-py-[0.8rem] tw-border tw-border-solid tw-border-[rgb(var(--color-foreground),0.3)] tw-rounded-[0.8rem]">
              <span class="quantity-decrease">
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.25 6.02216C11.25 6.12161 11.2105 6.21699 11.1402 6.28732C11.0698 6.35765 10.9745 6.39716 10.875 6.39716H2.625C2.52554 6.39716 2.43016 6.35765 2.35984 6.28732C2.28951 6.21699 2.25 6.12161 2.25 6.02216C2.25 5.9227 2.28951 5.82732 2.35984 5.75699C2.43016 5.68666 2.52554 5.64716 2.625 5.64716H10.875C10.9745 5.64716 11.0698 5.68666 11.1402 5.75699C11.2105 5.82732 11.25 5.9227 11.25 6.02216Z" fill="white"/>
                </svg>
              </span>
              <input type="text" name="quantity-input" readonly class="quantity-input" value = "1">
              <span class="quantity-increase">
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.25 6.02216C11.25 6.12161 11.2105 6.21699 11.1402 6.28732C11.0698 6.35765 10.9745 6.39716 10.875 6.39716H7.125V10.1472C7.125 10.2466 7.08549 10.342 7.01517 10.4123C6.94484 10.4826 6.84946 10.5222 6.75 10.5222C6.65054 10.5222 6.55516 10.4826 6.48484 10.4123C6.41451 10.342 6.375 10.2466 6.375 10.1472V6.39716H2.625C2.52554 6.39716 2.43016 6.35765 2.35984 6.28732C2.28951 6.21699 2.25 6.12161 2.25 6.02216C2.25 5.9227 2.28951 5.82732 2.35984 5.75699C2.43016 5.68666 2.52554 5.64716 2.625 5.64716H6.375V1.89716C6.375 1.7977 6.41451 1.70232 6.48484 1.63199C6.55516 1.56166 6.65054 1.52216 6.75 1.52216C6.84946 1.52216 6.94484 1.56166 7.01517 1.63199C7.08549 1.70232 7.125 1.7977 7.125 1.89716V5.64716H10.875C10.9745 5.64716 11.0698 5.68666 11.1402 5.75699C11.2105 5.82732 11.25 5.9227 11.25 6.02216Z" fill="white"/>
                </svg>
              </span>
            </div>
          </div>
        </li>
      `
    }

    renderCheckboxSelector(stepData, checkboxContainer){
      let filteredProducts = [];
      const stepTitle = stepData.title.toLowerCase();
      const isCompatibilityRequiredStep = stepData.check_compatibility;

      if (this.currentStepIndex === 0 || !isCompatibilityRequiredStep) {
        filteredProducts = this.collectionProducts.filter((product) => product.step_type.toLowerCase() === stepTitle);
      }
      else {
        filteredProducts = this.renderCompatibleProducts(stepData.title);
      }

      if(filteredProducts.length === 0) {
        this.showErrorNotification("There are no related products available for this step");
        return;
      }

      const uniqueBrands = [...new Set(filteredProducts.map(product => product.brand?.toLowerCase()))];

      if(uniqueBrands.length === 0) return;

      checkboxContainer.innerHTML = `
        <div class="checkbox-brand-list">
          ${uniqueBrands
            .map(
              (brand) => `
            <label class="checkbox-brand">
              <input type="checkbox" name="brand" value="${brand}">
              <span class="custom-check"></span>
              ${brand}
            </label>
          `
            )
            .join("")}
        </div>
      `;

      const checkboxes = checkboxContainer.querySelectorAll("input[type='checkbox']");
      const stepProducts = this.stepsDetailsList[this.currentStepIndex].stepProducts;
      this.toggleCheckbox(checkboxes, stepProducts);

      checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', (event) => {
          const checkedBrand = event.target.value;
          const brandProducts = filteredProducts.filter((product) => product.brand === checkedBrand);
          this.renderPopupWithProducts(brandProducts, stepData, checkboxes, checkbox);
        })
      })
    }

    renderCompatibleProducts(stepTitle) {
      const formattedTitle = `compatible${this.toPascalCase(stepTitle)}`;
      let commonProducts = [];
      for (let i = this.currentStepIndex - 1; i >= 0; i--) {
        const step = this.steps[i];
        const stepData = step.dataset.meta ? JSON.parse(step.dataset.meta) : null;
        if(!stepData.check_compatibility) continue;

        const prevStepProducts = this.stepsDetailsList[i].stepProducts;
        const allCompatibles = prevStepProducts.map((sp) => {
          const productData = this.collectionProducts.find((p) => p.id === sp.id);
          return productData?.[formattedTitle] || [];
        });

        if (allCompatibles.length === 0) return [];

        const commonIds = allCompatibles.reduce((acc, curr) => {
          const setCurr = new Set(curr);
          return acc.filter(id => setCurr.has(id));
        });

        commonProducts = this.collectionProducts.filter(p => commonIds.includes(p.id));
        break;
      }
      return commonProducts;
    }

    toPascalCase(stepTitle){
      return stepTitle
      .toLowerCase()
      .split(/\s+/)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join('');  
    }

    renderSelectBtns(newBtn = null){
      const stepProducts = this.stepsDetailsList[this.currentStepIndex].stepProducts;
      const popupBtnList = this.stepDetailContainer.querySelector(".pc-build-step-detail__open-popup-list");
      const parser = new DOMParser();

      if (stepProducts.length > 0 && newBtn === null) {
        stepProducts.forEach((stepProduct) => {
          const popupBtn = this.addSelectBtn(stepProduct);
          const parsedpopupBtn = parser.parseFromString(popupBtn, 'text/html');
          const selectBtnItem = parsedpopupBtn.querySelector(".pc-build-step-detail__open-item");
          const quantitySelector = selectBtnItem.querySelector('.popup-btn-qty-selector');
          quantitySelector.querySelector(".quantity-input").value = stepProduct.quantity
          
          quantitySelector.setAttribute('data-product-id', stepProduct.id);
          popupBtnList.appendChild(selectBtnItem);
  
          if (quantitySelector.classList.contains('hidden')) quantitySelector.classList.remove('hidden');
          
          this.handleQuantiySelector(quantitySelector, stepProducts);
        });
      }
      else {
        const popupBtn = this.addSelectBtn();
        popupBtnList.insertAdjacentHTML('beforeend', popupBtn);
      }

      const step = this.steps[this.currentStepIndex];
      const stepData = step.dataset.meta ? JSON.parse(step.dataset.meta) : null;
      const popupBtns = this.stepDetailContainer.querySelectorAll(".pc-build-step-detail__open-popup");
      popupBtns.forEach((popupBtn, index) => {
        popupBtn.onclick = () => {
          if (this.popupType === "popup") {
            this.openPopup(stepData, popupBtn, index);
          }
          else {
            this.openPopupWithFilters(stepData, popupBtn, index);
          }
        };
      });
    }

    renderPopupWithProducts(popupProducts, stepData, checkboxes, checkbox) {

      this.popup = document.createElement("div");
      this.popup.className = "steps-popup";
      const stepTitle = stepData.title.toLowerCase();
      const isMultiSelectionStep = stepData.isMultiSelectionStep;


      this.popup.innerHTML = `
        <div class="popup-inner">
          <div class="popup-container">
            <div class="popup-header">
              <button data-close-popup class="pc-build-step-detail__close-popup popup-close-btn"></button>
              <h2>Choose ${stepData.title}</h2>
            </div>
            <div class="popup-product-list">
              ${this.renderProductItems(popupProducts)}
            </div>
            <div class="popup-actions">
              <button class="pc-build-step-detail__confirm-selection popup-confirm-btn" data-confirm-selection disabled>Done</button> 
            </div>
          </div>
        </div>
      `;

      document.body.appendChild(this.popup);
      document.body.classList.add("overflow-hidden");

      popupProducts = this.popup.querySelectorAll('.popup-product');
      const confirmBtn = this.popup.querySelector(".pc-build-step-detail__confirm-selection");
      let selectedProducts = [];
      if (this.stepsDetailsList[this.currentStepIndex].stepProducts.length > 0) {
        selectedProducts = [...this.stepsDetailsList[this.currentStepIndex].stepProducts];
      }

      popupProducts.forEach((popupProduct) => {
        selectedProducts.forEach((selectedProudct) => selectedProudct.id === popupProduct.dataset.id && popupProduct.classList.add('selected'));

        popupProduct.addEventListener('click', () => {

          if (selectedProducts.length > 0) {
            if (selectedProducts[0].brand !== checkbox.value) {
              selectedProducts.length = 0;
              checkboxes.forEach((ec) => ec.checked = false);
            }
          }

          if (isMultiSelectionStep) {
            if (popupProduct.classList.contains('selected')) {
              popupProduct.classList.remove('selected');
              const unselectedProductIndex = selectedProducts.findIndex((selectedProduct) => selectedProduct.id === popupProduct.dataset.id);
              selectedProducts.splice(unselectedProductIndex, 1);
            }
            else {
              popupProduct.classList.add('selected');
              const selectedProduct = this.appendSelectedProduct(popupProduct, stepTitle);
              selectedProducts.push(selectedProduct);
            }
          }
          else {
            popupProducts.forEach((p) => p.classList.remove('selected'));
            selectedProducts.length = 0;
            const selectedProduct = this.appendSelectedProduct(popupProduct, stepTitle);
            popupProduct.classList.add('selected');
            selectedProducts.push(selectedProduct);
          }
          selectedProducts.length > 0 ? confirmBtn.disabled = false : confirmBtn.disabled = true;
        })
      });

      selectedProducts.length > 0 ? confirmBtn.disabled = false : confirmBtn.disabled = true;

      this.popup.addEventListener("click", (e) => {
        if (e.target === this.popup) {
          this.toggleCheckbox(checkboxes);
          this.closePopup();
        }
      });

      this.popup.querySelector('.pc-build-step-detail__close-popup').addEventListener('click', () => {
        this.toggleCheckbox(checkboxes);
        this.closePopup()
      });

      confirmBtn.addEventListener("click", () => {
        selectedProducts.length > 0 ? confirmBtn.disabled = false : confirmBtn.disabled = true;
        const isSelectedProductsAreSame = this.arraysHaveSameIds(this.stepsDetailsList[this.currentStepIndex].stepProducts, [...selectedProducts]);
        if (!isSelectedProductsAreSame) {
          this.stepsDetailsList.forEach((eachDetails, index) => {
            if (index > this.currentStepIndex) {
              eachDetails.stepProducts.length = 0;
              this.renderSelectedProduct(index);
            }
          })
        }
        this.stepsDetailsList[this.currentStepIndex].stepProducts = [...selectedProducts];
        this.toggleCheckbox(checkboxes);
        this.selectProduct();
        this.closePopup();
      });
    }

    toggleCheckbox(checkboxes){
      checkboxes.forEach((ec) => ec.checked = false);
      if (this.stepsDetailsList[this.currentStepIndex].stepProducts.length > 0) {
        const selectedBrand = this.stepsDetailsList[this.currentStepIndex].stepProducts[0].brand;
        checkboxes.forEach((checkbox) => {
          if (checkbox.value === selectedBrand) checkbox.checked = true;
        })
      }
    }

    arraysHaveSameIds(a, b) {
      if (a.length !== b.length) return false;

      const normalize = obj => `${obj.id}::${obj.variant_id}`;

      const aKeys = a.map(normalize).sort();
      const bKeys = b.map(normalize).sort();

      return aKeys.every((val, i) => val === bKeys[i]);
    }

    openPopup(stepData, selectBtn, selectBtnIndex) {
      const stepTitle = stepData.title.toLowerCase();
      const isCompatibilityRequiredStep = stepData.check_compatibility;

      if (this.currentStepIndex === 0 || !isCompatibilityRequiredStep) {
        filteredProducts = this.collectionProducts.filter((product) => product.step_type.toLowerCase() === stepTitle);
      }
      else {
        filteredProducts = this.renderCompatibleProducts(stepData.title);
      }


      if (!filteredProducts.length) {
        this.showErrorNotification("No products available for this step.");
        return;
      }
      else {
        this.renderSelectPopupWithProducts(filteredProducts, stepData, selectBtn, selectBtnIndex);
      }
    }

    openPopupWithFilters(stepData, selectBtn, selectBtnIndex) {
      if (this.popup) this.closePopup();

      const stepTitle = stepData.title.toLowerCase();
      const isCompatibilityRequiredStep = stepData.check_compatibility;
      
      let originalProducts = null;
      if (this.currentStepIndex === 0 || !isCompatibilityRequiredStep) {
        originalProducts = this.collectionProducts.filter((product) => product.step_type.toLowerCase() === stepTitle);
      }
      else {
        originalProducts = this.renderCompatibleProducts(stepData.title);
      }

      const stepSelectedProducts = this.stepsDetailsList[this.currentStepIndex].stepProducts;
      const stepFilteredProuducts = stepSelectedProducts.length === 0 
      ? originalProducts 
      : originalProducts.filter((product) => {
          return stepSelectedProducts.every(
            (sp) => sp.id !== product.id || selectBtn.dataset.productId === sp.id
          )
        })

      const uniqueBrands = [
        ...new Set(stepFilteredProuducts.map((p) => p.brand || "Others")),
      ];
      let filteredProducts = [...stepFilteredProuducts];

      this.popup = document.createElement("div");
      this.popup.className = "steps-popup";

      this.popup.innerHTML = `
        <div class="popup-inner">
          <div class="popup-header">
            <button data-close-popup class="pc-build-step-detail__close-popup popup-close-btn"></button>
            <h2>Choose ${stepTitle}</h2>
          </div>
          <div class="filter-popup-container">
            <!-- Left Filters -->
            <div class="brand-filter small-hide">
              <h4 class="brand-heading">BRAND</h4>
              <div class="brand-list checkbox-brand-list">
                ${uniqueBrands
                  .map(
                    (brand) => `
                    <div>
                      <label class="checkbox-brand">
                        <input type="checkbox" class="brand-checkbox desktop-checkbox" data-brand="${brand}" value="${brand}"> ${brand}
                        <span class="custom-check"></span>
                      </label>
                    </div>`
                  )
                  .join("")}
              </div>
              <div class="clear-brands-container">
                <a href="#" class="clear-brands desktop-clear">Clear All</a>
              </div>
            </div>

            <!-- Right Side: Search, Sort, Tags, Products -->
            <div class="popup-search-sort-container">
              <div class="filter-controls">
                <div class="mobile-brand-filter">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <path d="M21.6197 5.2678C21.5043 5.00109 21.313 4.7742 21.0696 4.61535C20.8263 4.4565 20.5416 4.3727 20.251 4.37436H3.75095C3.46064 4.37494 3.17673 4.45974 2.93366 4.6185C2.6906 4.77725 2.49883 5.00313 2.38161 5.26872C2.26439 5.53432 2.22677 5.82823 2.2733 6.11479C2.31984 6.40135 2.44853 6.66825 2.64376 6.88311L2.65126 6.89155L9.00095 13.6716V20.8744C9.00089 21.1458 9.0745 21.4123 9.21395 21.6452C9.35339 21.8781 9.55344 22.0688 9.79275 22.197C10.0321 22.3252 10.3017 22.386 10.5729 22.373C10.844 22.36 11.1066 22.2736 11.3325 22.1231L14.3325 20.1225C14.5382 19.9855 14.7068 19.7998 14.8234 19.582C14.94 19.3641 15.001 19.1208 15.001 18.8737V13.6716L21.3516 6.89155L21.3591 6.88311C21.5564 6.66923 21.6863 6.40198 21.7327 6.11471C21.779 5.82744 21.7397 5.53288 21.6197 5.2678ZM13.7053 12.8662C13.5756 13.0038 13.5026 13.1853 13.501 13.3744V18.8737L10.501 20.8744V13.3744C10.501 13.1839 10.4286 13.0006 10.2985 12.8616L3.75095 5.87436H20.251L13.7053 12.8662Z" fill="white"/>
                  </svg>
                </div>
                <input type="search" id="search-input" placeholder="Search" />
                <select id="sort-select">
                  <option value="name-asc">Title A-Z</option>
                  <option value="name-desc">Title Z-A</option>
                  <option value="price-asc">Price Low to High</option>
                  <option value="price-desc">Price High to Low</option>
                </select>
              </div>

              <div class="brand-tags"></div>

              <div class="popup-product-list">
                ${this.renderProductItems(filteredProducts)}
              </div>

              <div class="brand-filter large-up-hide medium-hide">
                <h4 class="brand-heading">BRAND</h4>
                <div class="brand-list checkbox-brand-list">
                  ${uniqueBrands
                    .map(
                      (brand) => `
                      <div>
                        <label class="checkbox-brand">
                          <input type="checkbox" class="brand-checkbox mobile-checkbox" data-brand="${brand}" value="${brand}"> ${brand}
                          <span class="custom-check"></span>
                        </label>
                      </div>`
                    )
                    .join("")}
                </div>
                <div class="clear-brands-container">
                  <a href="#" class="clear-brands mobile-clear">Clear All</a>
                </div>
              </div>

              <div class="popup-actions">
                <button id="confirm-selection-btn" class="pc-build-step-detail__confirm-selection popup-confirm-btn" data-confirm-selection>Done</button>
              </div>
            </div>
          </div>
        </div>
      `;

      document.body.appendChild(this.popup);
      document.body.classList.add("overflow-hidden");

      this.popup.addEventListener("click", (e) => {
        if (e.target === this.popup) {
          this.closePopup();
        }
      });

      const searchInput = this.popup.querySelector("#search-input");
      const sortSelect = this.popup.querySelector("#sort-select");
      const desktopCheckboxes = this.popup.querySelectorAll(".desktop-checkbox");
      const mobileCheckboxes = this.popup.querySelectorAll(".mobile-checkbox");
      const allCheckboxes = this.popup.querySelectorAll(".brand-checkbox");
      const clearBrandsDesktop = this.popup.querySelector(".desktop-clear");
      const clearBrandsMobile = this.popup.querySelector(".mobile-clear");
      const tagContainer = this.popup.querySelector(".brand-tags");
      const productList = this.popup.querySelector(".popup-product-list");
      const popupProducts = productList.querySelectorAll(".popup-product")
      const confirmBtn = this.popup.querySelector(".pc-build-step-detail__confirm-selection");
      const selectedBtnTitle = selectBtn.dataset.title;

      let selectedProduct = null;
      popupProducts.forEach((popupProduct) => {
        const popupProductTitle = popupProduct.dataset.title;
        if (selectedBtnTitle !== "Select" && selectedBtnTitle === popupProductTitle) {
          popupProduct.classList.add('selected');
        }
        popupProduct.addEventListener('click', (e) => {
          popupProducts.forEach((p) => p.classList.remove('selected'));
          selectedProduct = this.appendSelectedProduct(popupProduct, stepTitle);
          popupProduct.classList.add('selected');
          if (selectedProduct) confirmBtn.disabled = false;
        })
      });

      const syncCheckboxes = (sourceCheckbox) => {
        const brand = sourceCheckbox.dataset.brand;
        const isChecked = sourceCheckbox.checked;
        
        allCheckboxes.forEach(cb => {
          if (cb.dataset.brand === brand && cb !== sourceCheckbox) {
            cb.checked = isChecked;
          }
        });
      };

      const updateProductList = () => {
        const searchText = searchInput.value.toLowerCase();
        const sortValue = sortSelect.value;
        
        const selectedBrands = Array.from(desktopCheckboxes)
          .filter((cb) => cb.checked)
          .map((cb) => cb.value);

        tagContainer.innerHTML = selectedBrands
          .map(
            (brand) => `
              <span class="brand-tag" data-brand="${brand}">
                ${brand} <span class="pc-build-step-detail__remove-brand" data-remove-brand="${brand}">×</span>
              </span>
            `
          )
          .join("");

        filteredProducts = originalProducts
          .filter((product) => product.title.toLowerCase().includes(searchText))
          .filter((product) =>
            selectedBrands.length
              ? selectedBrands.includes(product.brand || "Others")
              : true
          );

        filteredProducts = this.sortProducts(filteredProducts, sortValue);
        productList.innerHTML = this.renderProductItems(filteredProducts);

        const popupProducts = productList.querySelectorAll(".popup-product");
        popupProducts.forEach((popupProduct) => {
          popupProduct.addEventListener('click', (e) => {
            popupProducts.forEach((p) => p.classList.remove('selected'));
            selectedProduct = this.appendSelectedProduct(popupProduct, stepTitle);
            popupProduct.classList.add('selected');
            if (selectedProduct) confirmBtn.disabled = false;
          })
        });

        tagContainer.querySelectorAll(".pc-build-step-detail__remove-brand").forEach((el) => {
          el.addEventListener("click", () => {
            const brandToRemove = el.dataset.removeBrand;
            
            allCheckboxes.forEach(cb => {
              if (cb.dataset.brand === brandToRemove) {
                cb.checked = false;
              }
            });
            
            updateProductList();
          });
        });
      };

      allCheckboxes.forEach((cb) => {
        cb.addEventListener("change", (e) => {
          syncCheckboxes(e.target);
          updateProductList();
        });
      });

      searchInput.addEventListener("input", updateProductList);
      sortSelect.addEventListener("change", updateProductList);

      const handleClearAll = (e) => {
        e.preventDefault();
        allCheckboxes.forEach((cb) => (cb.checked = false));
        updateProductList();
      };

      clearBrandsDesktop.addEventListener("click", handleClearAll);
      clearBrandsMobile.addEventListener("click", handleClearAll);

      this.popup
        .querySelector(".pc-build-step-detail__close-popup")
        ?.addEventListener("click", () => {
          this.closePopup();
        });

      const mobileBrandFilterIcon = this.popup.querySelector('.mobile-brand-filter');
      const brandFilterEl = this.popup.querySelectorAll('.brand-filter');
      const popupProductList = this.popup.querySelector('.popup-product-list');
      const popupActions = this.popup.querySelector('.popup-actions');

      if (mobileBrandFilterIcon) {
        mobileBrandFilterIcon.addEventListener('click', () => {
          brandFilterEl.forEach(el => {
            el.classList.toggle('show-on-mobile');
          });
          popupProductList.classList.toggle('hide-on-mobile');
          popupActions.classList.toggle('hidden');
        });
      }


      confirmBtn.addEventListener("click", () => {
        if (selectedProduct) {
          const stepProducts = this.stepsDetailsList[this.currentStepIndex].stepProducts;
          const selectBtnItem = selectBtn.closest(".pc-build-step-detail__open-item");
          const quantitySelector = selectBtnItem.querySelector('.popup-btn-qty-selector');
          quantitySelector.setAttribute('data-product-id', selectedProduct.id);
          selectBtn.dataset.title = selectedProduct.title;
          selectBtn.dataset.productId = selectedProduct.id;

          if (quantitySelector.classList.contains('hidden')) quantitySelector.classList.remove('hidden');

          if (stepProducts.length > 0 && stepProducts[selectBtnIndex]) {
            stepProducts.splice(selectBtnIndex, 1, selectedProduct);
            quantitySelector.querySelector('.quantity-input').value = 1;
          }
          else {
            stepProducts.push(selectedProduct);
          }

          this.stepsDetailsList.forEach((eachDetails, index) => {
            if (index > this.currentStepIndex) {
              eachDetails.stepProducts.length = 0;
              this.renderSelectedProduct(index);
            }
          })

          this.handleQuantiySelector(quantitySelector, stepProducts);
          this.selectProduct(selectedProduct, selectBtn);
        }
        this.closePopup();
      });
    }

    sortProducts(products, sortValue) {
      const sorted = [...products];
      switch (sortValue) {
        case "price-asc":
          return sorted.sort((a, b) => a.price - b.price);
        case "price-desc":
          return sorted.sort((a, b) => b.price - a.price);
        case "name-asc":
          return sorted.sort((a, b) => a.title.localeCompare(b.title));
        case "name-desc":
          return sorted.sort((a, b) => b.title.localeCompare(a.title));
        default:
          return sorted;
      }
    }

    renderSelectPopupWithProducts(popupProducts, stepData, selectBtn, selectBtnIndex) {
      this.popup = document.createElement("div");
      this.popup.className = "steps-popup";
      const stepTitle = stepData.title.toLowerCase();
      const stepSelectedProducts = this.stepsDetailsList[this.currentStepIndex].stepProducts;

      const filterdProducts = stepSelectedProducts.length === 0 
      ? popupProducts 
      : popupProducts.filter((product) => {
          return stepSelectedProducts.every(
            (sp) => sp.id !== product.id || selectBtn.dataset.productId === sp.id
          )
        })

      this.popup.innerHTML = `
        <div class="popup-inner">
          <div class="popup-container">
            <div class="popup-header">
              <button data-close-popup class="pc-build-step-detail__close-popup popup-close-btn"></button>
              <h2>Choose ${stepData.title}</h2>
            </div>
            <div class="popup-product-list">
              ${this.renderProductItems(filterdProducts)}
            </div>
            <div class="popup-actions">
              <button class="pc-build-step-detail__confirm-selection popup-confirm-btn" data-confirm-selection disabled>Done</button> 
            </div>
          </div>
        </div>
      `;

      document.body.appendChild(this.popup);
      document.body.classList.add("overflow-hidden");

      popupProducts = this.popup.querySelectorAll('.popup-product');
      const confirmBtn = this.popup.querySelector(".pc-build-step-detail__confirm-selection");
      if(stepSelectedProducts.length) confirmBtn.disabled = false;
      const selectedBtnTitle = selectBtn.dataset.title;
      
      let selectedProduct = null;
      popupProducts.forEach((popupProduct) => {
        const popupProductTitle = popupProduct.dataset.title;
        if (selectedBtnTitle !== "Select" && selectedBtnTitle === popupProductTitle) {
          popupProduct.classList.add('selected');
        }
        popupProduct.addEventListener('click', (e) => {
          popupProducts.forEach((p) => p.classList.remove('selected'));
          selectedProduct = this.appendSelectedProduct(popupProduct, stepTitle);
          popupProduct.classList.add('selected');
          if (selectedProduct) confirmBtn.disabled = false;
        })
      });

      this.popup.addEventListener("click", (e) => {
        if (e.target === this.popup) {
          this.closePopup();
        }
      });

      this.popup.querySelector('.pc-build-step-detail__close-popup').addEventListener('click', () => {
        this.closePopup()
      });

      confirmBtn.addEventListener("click", () => {
        if (selectedProduct) {
          const stepProducts = this.stepsDetailsList[this.currentStepIndex].stepProducts;
          const selectBtnItem = selectBtn.closest(".pc-build-step-detail__open-item");
          const quantitySelector = selectBtnItem.querySelector('.popup-btn-qty-selector');
          quantitySelector.setAttribute('data-product-id', selectedProduct.id);
          selectBtn.dataset.title = selectedProduct.title;
          selectBtn.dataset.productId = selectedProduct.id;

          if (quantitySelector.classList.contains('hidden')) quantitySelector.classList.remove('hidden');

          if (stepProducts.length > 0 && stepProducts[selectBtnIndex]) {
            stepProducts.splice(selectBtnIndex, 1, selectedProduct);
            quantitySelector.querySelector('.quantity-input').value = 1;
          }
          else {
            stepProducts.push(selectedProduct);
          }

          this.stepsDetailsList.forEach((eachDetails, index) => {
            if (index > this.currentStepIndex) {
              eachDetails.stepProducts.length = 0;
              this.renderSelectedProduct(index);
            }
          })

          this.handleQuantiySelector(quantitySelector, stepProducts);
          this.selectProduct(selectedProduct, selectBtn);
        }
        this.closePopup();
      });
    }

    handleQuantiySelector(quantityContainer, stepProducts){
      const productId = quantityContainer.dataset.productId;
      const increaseBtn = quantityContainer.querySelector('.quantity-increase');
      const decreaseBtn = quantityContainer.querySelector('.quantity-decrease');
      const quantityInput = quantityContainer.querySelector('.quantity-input');
      
      increaseBtn.addEventListener('click', () => {
        const prevQuantity = parseInt(quantityInput.value);
        if (prevQuantity >= 5) {
          this.showErrorNotification("You can add max 5 products");
        }
        else {
          const updatedQuantity = prevQuantity + 1;
          quantityInput.value = updatedQuantity;
  
          this.stepsDetailsList[this.currentStepIndex].stepProducts = stepProducts.map((eachProduct) => {
            if (eachProduct.id === productId) {
              return {...eachProduct, quantity: updatedQuantity, totalPrice: eachProduct.price * updatedQuantity }
            }
            return eachProduct
          })
          this.selectProduct();
        }
      })

      decreaseBtn.addEventListener('click', () => {
        const prevQuantity = parseInt(quantityInput.value);
        if (prevQuantity > 1) {
          const updatedQuantity = prevQuantity - 1;
          quantityInput.value = updatedQuantity;

          this.stepsDetailsList[this.currentStepIndex].stepProducts = stepProducts.map((eachProduct) => {
            if (eachProduct.id === productId) {
              return {...eachProduct, quantity: updatedQuantity, totalPrice: eachProduct.price * updatedQuantity }
            }
            return eachProduct
          })
          this.selectProduct();
        }
        else {
          const productIndex = stepProducts.findIndex((product) => productId === product.id);
          this.stepsDetailsList[this.currentStepIndex].stepProducts.splice(productIndex, 1);
          const selectBtnsList = this.stepDetailContainer.querySelector(".pc-build-step-detail__open-popup-list");
          selectBtnsList.innerHTML = "";
          this.renderSelectBtns();
          this.selectProduct();
        }
      })

    }

    getAllStepsProducts(){
      const noOfSteps = this.steps.length;
      let allStepsProducts = [];
      for (let index = 0; index < noOfSteps; index++) {
        const stepProducts = this.stepsDetailsList[index].stepProducts;
        allStepsProducts.push([stepProducts]);
      }

      return allStepsProducts;
    }

    selectProduct(product, selectBtn = null){

      this.renderSelectedProduct(this.currentStepIndex);
      this.updateTotal();

      if (product && selectBtn) {
        const productText = selectBtn.querySelector(
          ".product-selected-text"
        );
        if (productText) {
          productText.querySelector('.popup-product-title').textContent = product.title;
          productText.querySelector('.popup-product-price').textContent = `KD ${product.price}`;
          productText.querySelector('.popup-product-price').classList.remove('hidden');
        }
      }


      const nextBtns = this.stepDetailContainer.querySelectorAll(".pc-build-step-detail__next-btn");
      if (nextBtns.length) {
        nextBtns.forEach(nextBtn => {
          nextBtn.classList.add("product-selected");
        });
      }
    }

    renderSelectedProduct(stepIndex) {
      const stepProducts = this.stepsDetailsList[stepIndex].stepProducts;
      const productsCount = stepProducts.length - 1;
      const stepEl = this.steps[stepIndex];
      const stepImage = stepEl.dataset.stepimage ? JSON.parse(stepEl.dataset.stepimage) : null;
      let totalPrice = 0;
      stepProducts.forEach((product) => totalPrice += product.totalPrice);

      this.stepsDetailsList.forEach((eachStep) => {
        const stepProductImage = this.querySelector(".pc-build-step-detail__image img");
        if(eachStep.stepName.toLowerCase() === "case" && eachStep.stepProducts.length > 0){
          stepProductImage.src = eachStep.stepProducts[0].image;
        }
        else if(eachStep.stepName.toLowerCase() === "case" && eachStep.stepProducts.length === 0) {
          stepProductImage.src = stepProductImage.dataset.image;
        }
      })

      if (stepEl) {
        const titleEl = stepEl.querySelector(".step-product-title");
        const priceEl = stepEl.querySelector(".step-product-price");
        const imageEl = stepEl.querySelector(".step-product-image");
        const countEl = stepEl.querySelector(".step-product-count");

        if(imageEl) {
          if (stepProducts.length > 0) {
            imageEl.src = stepProducts[0].image;
            imageEl.alt = stepProducts[0].title;
          } else {
            imageEl.src = stepImage;
            imageEl.alt = "Step Image";
          }
        }
        if (titleEl) titleEl.textContent = stepProducts[0]?.title || "Please select";            
        if (priceEl) {
          if (stepProducts.length > 0) {
            priceEl.textContent = `KD ${totalPrice}`;
            if (productsCount === 0) countEl.textContent = "";
            if (productsCount === 1) countEl.textContent = `+${productsCount} Product`;
            if (productsCount > 1) countEl.textContent = `+${productsCount} Products`;
            priceEl.classList.add("price-green");
          } else {
            priceEl.textContent = "KD 0.00";
            countEl.textContent = "";
            priceEl.classList.remove("price-green");
          }
        }
      }
    }

    appendSelectedProduct(popupProduct, stepTitle){
      return (
        {
          id: popupProduct.dataset.id,
          productHandle: popupProduct.dataset.handle,
          image: popupProduct.dataset.image,
          variant_id: popupProduct.dataset.variantid,
          title: popupProduct.querySelector(".popup-product-title")?.textContent || "Unknown Product",
          price: parseFloat(popupProduct.dataset.price),
          totalPrice: parseFloat(popupProduct.dataset.price),
          quantity: 1,
          stepIndex: this.currentStepIndex,
          stepType: stepTitle,
          brand: popupProduct.dataset.brand || ""
        }
      );
    }

    renderProductItems(popupProducts, stepType = false) {
      let stepTypeList = [];

      return popupProducts.map(product => {
        let stepTypeMarkup = "";

        if (stepType && product.stepType) {
          if (!stepTypeList.includes(product.stepType)) {
            stepTypeMarkup = `<p class="popup-product-steptype">${product.stepType}</p>`;
            stepTypeList.push(product.stepType);
          }
        }

        return `
          ${stepType ? stepTypeMarkup : ""}
            <div class="popup-product" 
              data-id="${product.id}" 
              data-handle="${product.product_handle}"
              data-image="${product.image}"
              data-brand="${product.brand}"
              data-variantid="${product.variant_id}" 
              data-price="${product.price}"
              data-title="${product.title}"
            >
            <div class="popup-product-details">
              <img src="${product.image}" alt="${product.title}" />
              ${!stepType ? `<p class="popup-product-price inner-price tw-self-start">KD ${stepType ? product.totalPrice : product.price}</p>` : ""}
              <h3 class="popup-product-title">${stepType ? product.title + " x " + product.quantity + " Qty" : product.title }</h3>
            </div>
            ${stepType ? `<div class="">
              <p class="popup-product-price outer-price">KD ${stepType ? product.totalPrice : product.price}</p>
            </div>` : ""}
          </div>
        `;
      }).join("");
    }

    updatePrevNextButtons() {
      const detailEl = this.querySelector(".pc-build-step-detail");
      const prevBtns = detailEl.querySelectorAll(".pc-build-step-detail__prev-btn");
      const nextBtns = detailEl.querySelectorAll(".pc-build-step-detail__next-btn");
      const stepIndex = this.currentStepIndex;

      prevBtns.forEach(prevBtn => {
        if (stepIndex === 0) {
          prevBtn.classList.remove("product-selected");
        } else {
          prevBtn.classList.add("product-selected");
        }
      });

      const isProductSelected = this.stepsDetailsList[stepIndex].stepProducts.length > 0 ? true : false;
      const currentStep = this.steps[stepIndex];
      const stepData = currentStep.dataset.meta ? JSON.parse(currentStep.dataset.meta) : null;
      const isRequiredStep = stepData ? stepData.required_step : null;
      nextBtns.forEach(nextBtn => {
        if (isProductSelected || !isRequiredStep) {
          nextBtn.classList.add("product-selected");
        } else {
          nextBtn.classList.remove("product-selected");
        }
        nextBtn.textContent = stepIndex === this.steps.length - 1 ? "Finish" : "Next";
      });
    }

    showTotalSummaryPopup() {
      if (this.popup) {
        this.closePopup();
      }

      this.popup = document.createElement("div");
      this.popup.className = "steps-popup";
      const noOfSteps = this.steps.length;
      let totalProductsPrice = 0;
      let allProducts = [];

      for (let index = 0; index < noOfSteps; index++) {
        const stepProducts = this.stepsDetailsList[index].stepProducts;
        if(stepProducts.length > 0){
          stepProducts.forEach((eachProduct) => totalProductsPrice += eachProduct.totalPrice);
          allProducts.push(...stepProducts);
        }
      }

      this.popup.innerHTML = `
        <div class="popup-inner">
          <div class="popup-container">
            <div class="popup-header">
              <button data-close-popup class="pc-build-step-detail__close-popup popup-close-btn"></button>
              <div class="popup-heading-badges tw-flex tw-flex-col tw-gap-4 md:tw-flex-row">
                <h2 class="popup-heading">order summary</h2>
                <div class="tw-flex tw-gap-4">
                  ${this.enableDiscount ? `<span>Get ${this.bundleDiscount}% Off</span>` : ""} 
                  <span>Free Delivery</span>
                </div>
              </div>
            </div>
            <div class="popup-product-list summary-popup">
              ${this.renderProductItems(allProducts, true)}
            </div>
            <div class="tw-flex tw-flex-col tw-items-end tw-gap-4 tw-my-6">
              <p class="bundle-total-price ${this.enableDiscount ? 'discount' : ""}"><span class="total-text">Total Price:</span> KD ${totalProductsPrice.toFixed(2)}</p>
              ${this.enableDiscount ? `<p class="bundle-total-price"><span class="total-text">Discount:</span> ${this.bundleDiscount}%</p>` : ""}
              ${this.enableDiscount ? `<p class="bundle-total-price"><span class="total-text">Net Price:</span> KD ${(totalProductsPrice - (totalProductsPrice * (this.bundleDiscount /100))).toFixed(2)}</p>` : ""}
            </div>
            <button class="pc-build-step-detail__submit-total-build bundle-total-atc" data-submit-total-build>Buy now</button>
          </div>
        </div>
      `;

      document.body.appendChild(this.popup);
      document.body.classList.add("overflow-hidden");

      this.popup.addEventListener("click", (e) => {
        if (e.target === this.popup) {
          this.closePopup();
        }
      });

      this.popup
        .querySelector(".pc-build-step-detail__submit-total-build")
        ?.addEventListener("click", () => {
          this.submitTotalBuild();
          this.closePopup();
        });

      this.popup
        .querySelector(".pc-build-step-detail__close-popup")
        ?.addEventListener("click", () => {
          this.closePopup();
        });
    }

    submitTotalBuild() {
      this.submitProductsToCart(false);
    }

    async submitProductsToCart(buyNow = false) {
      if (this.isSubmitting) return;

      const noOfSteps = this.steps.length;
      let totalStepsProducts = [];
      for (let index = 0; index < noOfSteps; index++) {
        const stepProducts = this.stepsDetailsList[index].stepProducts;
        if(stepProducts.length > 0){
          totalStepsProducts.push(...stepProducts);
        }
      }

      if (!totalStepsProducts.length) {
        this.showErrorNotification("No products selected!");
        return;
      }

      this.isSubmitting = true;
      try {
        const bundleGroupId = `build-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
        const formData = {
          items: totalStepsProducts.map((product) => ({
            id: parseInt(product.variant_id, 10),
            quantity: product.quantity,
            properties: {
              Bundle: "Build Your PC",
              BundleGroup: bundleGroupId,
            },
          })),
        };

        if (this.cart) {
          formData.sections = this.cart
            .getSectionsToRender()
            .map((section) => section.id);
          formData.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || "Shopify rejected the cart request.");
        }

        this.cart?.classList.remove("is-empty");
        if (!buyNow) {
          this.cart?.renderContents(data);
        } else {
          window.location.href = "/checkout";
        }
      } catch (error) {
        console.error("Error adding to cart:", error);
        this.showErrorNotification("Failed to add products to cart. Please try again.");
      } finally {
        this.isSubmitting = false;
      }
    }

    addToCart() {
      this.submitProductsToCart(false);
    }

    buyNow() {
      this.submitProductsToCart(true);
    }

    updateTotal() {
      const noOfSteps = this.steps.length;
      let totalProductsPrice = 0;
      for (let index = 0; index < noOfSteps; index++) {
        const stepProducts = this.stepsDetailsList[index].stepProducts;
        if(stepProducts.length > 0){
          stepProducts.forEach((eachProduct) => totalProductsPrice += eachProduct.totalPrice);
        }
      }

      if (this.totalPriceEl) {
        this.totalPriceEl.textContent = `KD ${totalProductsPrice}`;
      }

      if (this.finalPriceEl) {
        this.finalPriceEl.textContent = `KD ${Math.ceil((totalProductsPrice - (totalProductsPrice * (this.bundleDiscount / 100))).toFixed(2))}`
      }

      if (totalProductsPrice > 0) {
        this.buyNowBtn.classList.add("active-product");
      } else {
        this.buyNowBtn.classList.remove("active-product");
      }
    }

    nextStep() {
      const stepProducts = this.stepsDetailsList[this.currentStepIndex].stepProducts;
      const currentStep = this.steps[this.currentStepIndex];
      const stepData = currentStep.dataset.meta ? JSON.parse(currentStep.dataset.meta) : null;
      const isRequiredStep = stepData ? stepData.required_step : null;

      if (stepProducts.length === 0 && isRequiredStep) {
        this.showErrorNotification("Please select a product before moving to the next step.");
        return;
      }

      if (this.currentStepIndex < this.steps.length - 1) {
        this.showStepDetail(this.currentStepIndex + 1);
      } else {
        console.log("Showing total summary popup");
        this.showTotalSummaryPopup();
      }
    }

    prevStep() {
      if (this.currentStepIndex > 0) {
        this.renderSelectedProduct(this.currentStepIndex);
        this.updateTotal();

        this.showStepDetail(this.currentStepIndex - 1);
      }
    }

    closePopup() {
      if (this.popup) {
        this.popup.remove();
        this.popup = null;
      }
      document.body.classList.remove("overflow-hidden");
    }

    toggleShowMoreSteps() {
      
      this.applyInitialState();

      this.toggleBtn.addEventListener("click", () => {
        this.wrapper.classList.toggle("collapsed");

        this.toggleBtn.textContent = this.wrapper.classList.contains("collapsed")
          ? "+Show Accessories"
          : "-Hide Accessories";
      });

      window.addEventListener("resize", this.applyInitialState);
    }

    applyInitialState() {
      if (window.innerWidth >= 768) {
        if (this.totalSteps <= 8) {
          this.wrapper.classList.remove("collapsed");
          this.toggleBtn.classList.add('hidden');
          return;
        }

        this.wrapper.classList.add("collapsed");
        this.toggleBtn.classList.remove('hidden');
        this.toggleBtn.textContent = "+Show Accessories";

      } else {
        this.wrapper.classList.remove("collapsed");
        this.toggleBtn.classList.add('hidden');
      }
    }
  }
  customElements.define("build-your-pc", BuildYourPC);
}